<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-[95] bg-[hsl(var(--background))] flex flex-col">
      <div class="shrink-0 flex items-center gap-2 bg-sheet border-b border-[hsl(var(--border)/0.6)] px-3 py-2">
        <button
          type="button"
          @click="emit('close')"
          class="w-11 h-11 rounded-full flex items-center justify-center hover:bg-[hsl(var(--muted))] transition-colors shrink-0"
          :aria-label="$t('aboutProject.backButton')"
        >
          <ArrowLeft class="w-4.5 h-4.5" />
        </button>
        <h1 class="min-w-0 text-[14px] font-semibold line-clamp-2">{{ parsed.title }}</h1>
      </div>

      <div class="flex-1 overflow-y-auto">
        <div class="max-w-2xl mx-auto px-4 py-7 sm:px-6 sm:py-10 md:py-14">
          <LegalDocumentLanguageSwitch v-model="selectedLocale" />
          <div class="mt-5 mb-8">
            <h2 class="text-[19px] sm:text-[21px] font-semibold leading-snug">{{ parsed.title }}</h2>
            <p v-if="parsed.revisionNote" class="mt-2 text-[12px] text-ink2">{{ parsed.revisionNote }}</p>
          </div>
          <LegalDocumentBody :markdown="markdown" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { ArrowLeft } from "lucide-vue-next";
import type { LegalDocument } from "../content/legalDocuments";
import { preferredLegalDocumentLocale } from "../content/legalDocuments";
import { parseLegalMarkdown } from "../utils/legalMarkdown";
import LegalDocumentBody from "./LegalDocumentBody.vue";
import LegalDocumentLanguageSwitch from "./LegalDocumentLanguageSwitch.vue";
import { useHistoryBackClose } from "../composables/useHistoryBackClose";

const props = defineProps<{ document: LegalDocument }>();
const emit = defineEmits<{
  (event: "close"): void;
}>();

const selectedLocale = ref(preferredLegalDocumentLocale(props.document));
const markdown = computed(() => props.document.translations[selectedLocale.value] || props.document.translations.kk);
const parsed = computed(() => parseLegalMarkdown(markdown.value));

watch(() => props.document.id, () => {
  selectedLocale.value = preferredLegalDocumentLocale(props.document);
});

useHistoryBackClose(() => emit("close"));
</script>
